











import { Component, Vue } from "vue-property-decorator";
import BlogCard from "./BlogCard.vue";
import posts from "./posts.json";

@Component({
  components: {
    BlogCard
  }
})
export default class Blog extends Vue {
  data() {
    return { posts };
  }
}
